import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import FeatureGate, { FEATURE_GATES } from 'components/FeatureGate';
import UsersSettingsProvider from 'contextProviders/UsersSettingsProvider';
import NAVIGATION from 'kingpin/navigation/constants';

import AccountLevelPortalSwitch from './AccountLevelPortalSwitch';
import UsersSidebarContainer from './UsersSidebarContainer';
import ExportUsersButton from '../ExportUsersButton';

const ScreenDiv = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const UsersNavOutletDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  width: 100%;
`;

const UserTopBar = styled.div`
  height: ${NAVIGATION.TOP_HEIGHT}px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid var(--color-border-secondary);
  padding: 0px 16px;
  gap: 8px;
`;

const UsersNav = () => {
  return (
    <ScreenDiv>
      <UsersSettingsProvider>
        <UsersSidebarContainer />
        <UsersNavOutletDiv>
          <UserTopBar>
            <FeatureGate
              featureName={FEATURE_GATES.PORTALS_ACCOUNT_WIDE_TOGGLE}
            >
              <AccountLevelPortalSwitch />
            </FeatureGate>
            <ExportUsersButton />
          </UserTopBar>
          <Outlet />
        </UsersNavOutletDiv>
      </UsersSettingsProvider>
    </ScreenDiv>
  );
};

export default UsersNav;
